<template>
  <div class="modules-content" style="margin-top:0px;">
    <div class="module-item" data-id="1" data-module-lessons="23">
      <div class="title-content custom-grid">
        <h3 class="module-title" style="font-size: 14px;">
          Ativos
          <i class="icon icon-alert-circle-i"></i>
          <div class="module-description-tooltip">Ativos</div>
          
        </h3>
        
        <span></span>

        <span></span>

        <span></span>
      </div>

      <li class="lesson-subtitle custom-grid-actives">
        <span class="lesson-title">Id</span>
        <span class="lesson-title">Nome</span>
        <span class="LastAccess">Último acceso no mês</span>
        <!-- <span class="lesson-option"></span> -->
      </li>
      
      <ul class="lessons-list">
        <li
          v-for="(data,index) in activesData"
          :key="index"
          class="lesson custom-grid-actives"
          data-id="64"
          data-videos="1"
        >
          <span class="lesson-title">{{data.userId}}</span>
          <span class="lesson-title">{{data.name}}</span>
          <span class="lesson-title">{{`${(new Date(data.activity).getDate().toString().length == 1) ? '0' + new Date(data.activity).getDate() : new Date(data.activity).getDate()}/${((new Date(data.activity).getMonth() + 1).toString().length == 1 ? '0'+(new Date(data.activity).getMonth() + 1) : (new Date(data.activity).getMonth() + 1))}/${new Date(data.activity).getFullYear()} ${new Date(data.activity).getHours()}:${new Date(data.activity).getMinutes()}:${new Date(data.activity).getSeconds()}`}}</span>

        </li>
      </ul>
      
    </div>
  </div>
</template>

<style lang="scss" scoped>
.custom-grid-actives {
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr !important;
  }
}
</style>

<script>
import axios from "axios";

export default {
  data(){
    return {
    }
  },
  props: {
    monthLabels: {
      type: Array,
      required: true
    }
  },
  components: {
   
  },
  props: {
    activesData: {
      type: Array,
      required: true
    },
    loadingData: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    getDate (e) {

      return ;
    }
  },
  created() {}
};
</script>
